import apiErrorHandler from '@/libraries/apiErrorHandler';
import DriverMetrics from '@/types/DriverMetrics';
import FbaApiError from '@/types/FbaApiError';
import axios from 'axios';

type Response = { isSuccessful: false } | { isSuccessful: true };

export default async function postDriverMetrics(
    driverMetricsData: DriverMetrics
): Promise<Response | FbaApiError> {
    try {
        const response = await axios({
            method: 'POST',
            url: `${process.env.VUE_APP_EXT_API_URL}api/drivers/driverMetrics`,
            data: driverMetricsData,
        });

        return response.data;
    } catch (error) {
        return apiErrorHandler(error);
    }
}
